(ns app.domain.public-notice.model
  (:require [app.domain.group.model :as group-model]))

(def document-types [:public-notice-document.type/note
                     :public-notice-document.type/opinion
                     :public-notice-document.type/public-notice
                     :public-notice-document.type/remark
                     :public-notice-document.type/other])


(def visibility [:public-notice-document.visibility/everyone
                 :public-notice-document.visibility/authorities])


(def contact-types [:public-notice-contact.type/self-registered
                    :public-notice-contact.type/manually-added])


(defn public-notice-template-from-group [authority-group]
  (-> authority-group
      (group-model/first-of-group :entity.type/public-notice-template)
      group-model/template-replacement))


(defn enabled-for?
  [permit-type]
  (-> permit-type
      #{:permit-type/P
        :permit-type/LU
        :permit-type/PWO}
      boolean))
